export enum ThirdParty {
  MBS = 0,
  Okra,
  Remita,
  Mono,
  Nibss
}